import http from "@/http-common";
import './security';

class SensorService {
  getAll() {
    return http.get("/sensor");
  }

  getLastMeasure(sensorid) {
    return http.get(`/sensor/measures/last/${sensorid}`);
  }

  getCustomColumnNames(sensorid) {
    return http.get(`/sensor/columns/${sensorid}`);
  }

  getCustomColumnHide(sensorid) {
    return http.get(`/sensor/hidden/${sensorid}`);
  }

  getSensorsFromDevice(deviceid) {
    return http.get(`/sensor/deviceid/${deviceid}`);
  }

  getAllTypes() {
    return http.get("/sensor/type");
  }

  get(id) {
    return http.get(`/sensor/id/${id}`);
  }

  create(data) {
    return http.post("/sensor", data);
  }

  // Add default sensor types
  fillSensorTypes() {
    return http.get("/sensor/fillTypes");
  }

  update(data) {
    return http.put(`/sensor/id/${data._id}`, data);
  }

  findTypeByAlias(alias) {
    if (!alias) {
      return http.get("/sensor");
    } else {
      return http.get(`/sensor/type/alias/?alias=${alias}`);
    }
  }

  getTypeFromSensorId(idsensor) {
    return http.get(`/sensor/type/id/${idsensor}`);
  }

  delete(id) {
    return http.delete(`/sensor/id/${id}`);
  }

  deleteAll() {
    return http.delete(`/sensor`);
  }

  deleteMeasures(id) {
    return http.delete(`/sensor/measures/${id}`);
  }

  getSensorByDescription(description) {
    return http.get(`/sensor/description/${description}`)
  }

  sendValveCommand(id, action){
    return http.get(`/sensor/mqttcommand/${id}?action=${action}`);
  }
  

}

export default new SensorService();
